import React, { useRef, useMemo, useState } from "react";
import "./App.css";
import { Button, IconButton, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import MuiAlert from "@material-ui/lab/Alert";
import meeLogo from "../src/assets/images/logo-mee.png";
import meepLogo from "../src/assets/images/logo-meep.png";
import enviroment from "./models/Enviroment";
import { TotemConfig } from "./models/totemConfig";
import { TotemConfigResult } from "./models/totemConfigResult";
import { TotemLogin } from "./models/totemLogin";
import { HttpRepository } from "./repositories/httpRepository";
import { formatCNPJ } from "./utils/utils";

const useStyles = makeStyles({
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    color: "#5F5F5F",
    textAlign: "center",
    fontFamily: "Ubuntu",
    fontSize: 40,
    fontWeight: 700,
  },
  item: {
    color: "#5F5F5F",
    textAlign: "center",
    fontFamily: "Ubuntu",
    fontSize: 18,
    fontWeight: 400,
  },
  version: {
    position: "absolute",
    left: 0,
    bottom: 0,
    fontFamily: "Ubuntu",
    color: "#5F5F5F",
    fontSize: 12,
  },
  copy: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  img: {
    justifySelf: "center",
    marginTop: 18,
  },
  info: {
    borderRadius: 12,
    border: "2px solid  #E0E0E0",
    background: "#FFF",
    color: "#5F5F5F",
    fontFamily: "Ubuntu",
    fontSize: 20,
    boxShadow: "none",
  },
  success: {
    borderRadius: 12,
    border: "2px solid  #399C54",
    background: "rgba(57, 156, 84, 0.10)",
    color: "#399C54",
    fontFamily: "Ubuntu",
    fontSize: 20,
    boxShadow: "none",
  },
  icon: {
    fontSize: 30,
  },
  buttons: {
    position: "absolute",
    bottom: 30,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  button: {
    display: "flex",
    padding: "20px 40px",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0 0",
    borderRadius: 12,
    textTransform: "none",
    fontFamily: "Ubuntu",
    fontSize: 20,
    fontWeight: 700,
    margin: "0 16px",
  },
});

declare const CefSharp: any;
declare const browserService: any;

function App() {
  const apiUrlBase = enviroment.apiUrl;

  const httpRepository = HttpRepository(apiUrlBase);

  const [messages, setMessages] = useState<
    Array<{ comando: number; message: string; severity: string }>
  >([]);

  const [imei, setImei] = useState<string>();
  const [cefSharpVersion, setCefSharpVersion] = useState<string>();
  const [totemConfig, setTotemConfig] = useState<TotemConfig>();
  const [jsonConfig, setJsonCOnfig] = useState<string>();
  const [isMee, setIsMee] = useState(false);

  const cefSharpVersionRef = useRef('');

  (window as any).showMessageFromClient = (
    message: string,
    comando: number,
    severity: string
  ) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      { comando: comando, message: message, severity: severity },
    ]);
  };

  (window as any).setCefSharpVersion = async (_cefSharpVersion: string) => {
    cefSharpVersionRef.current = _cefSharpVersion
    setCefSharpVersion(_cefSharpVersion);
  }

  (window as any).setConfigTotem = async (macAddress: string) => {
    setImei(macAddress);
    try {
      const totemLogin = await httpRepository.postAsync<any, TotemLogin>(
        "api/UsuarioMeepPOS/LoginAutomaticoPOS",
        {
          IMEI: macAddress,
        }
      );

      const totemConfigResult = await httpRepository.postAsync<
        any,
        TotemConfigResult
      >(
        "api/UsuarioMeepPOS/AtualizarDadosEquipamento",
        {
          IMEI: macAddress,
          UsuarioMeepPOSId: totemLogin.usuarioMeepPOSId,
          VersaoCefSharpTotem: cefSharpVersionRef.current,
        },
        totemLogin.token
      );
      console.log(totemConfigResult);
      const _isMee = totemConfigResult?.identificadorSistema === 1;
      const appUrl = (_isMee || totemConfigResult.deveUsarTotemNovo) ? enviroment.meeAppUrl : enviroment.appUrl;
      const conf: TotemConfig = {
        PrintQRCodeTicket: totemConfigResult.imprimirQRCodeFicha,
        CNPJ: totemConfigResult.CNPJ,
        PrintType: totemConfigResult.tipoImpressao,
        TickectName: totemConfigResult.localNome,
        TicketNote: totemConfigResult.observacaoFicha,
        UserAgent: totemConfigResult.usuarioMeepPOSApelido,
        EquipamentId: totemConfigResult.usuarioMeepPOSId,
        UrlApp: appUrl,
        Token: totemLogin.token,
        StoreCode: totemConfigResult.codigoUnico,
        AddressLocalServer: totemConfigResult.enderecoServidorLocal,
        SoftExpressCnpj: totemConfigResult.softExpressCnpj,
        SoftExpressToken: totemConfigResult.softExpressToken,
        SoftExpressStoreCode: totemConfigResult.softExpressStoreCode,        
        SoftExpressCnpjMeepSub: totemConfigResult.softExpressCnpjMeepSub,
        SoftExpressStoreCodeMeepSub: totemConfigResult.softExpressStoreCodeMeepSub,
        SoftExpressIsPagSeguroSubAcquirer: totemConfigResult?.softExpressIsPagSeguroSubAcquirer,        
        SoftExpressOwnerName: totemConfigResult?.softExpressPagSeguroSubAcquirerData?.name,
        SoftExpressOwnerAddress:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.address,
        SoftExpressOwnerCity:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.city,
        SoftExpressOwnerUf:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.uf,
        SoftExpressOwnerCountry:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.country,
        SoftExpressOwnerZipCode:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.zipCode,
        SoftExpressOwnerMcc:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.mcc,
        SoftExpressOwnerCnpjCpf:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.cnpjCpf,
        SoftExpressOwnerTelephone:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.telephone,
        SoftExpressOwnerMerchantId:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.merchantId,
        SoftExpressOwnerFullName:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.fullName,
        SoftExpressOwnerDocType:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.docType,
        SoftExpressOwnerFacilitatorMerchantId:  totemConfigResult?.softExpressPagSeguroSubAcquirerData?.facilitatorMerchantId,
        AcquirerType: totemConfigResult.tipoAdquirente,
        PaygoPassword: totemConfigResult.paygoPassword,
        PaygoPOSId: totemConfigResult.paygoPOSId,
        PaygoCnpj: totemConfigResult.paygoCnpj,
        PaygoIP: totemConfigResult.paygoIP,
      };
      setIsMee(_isMee);
      setConfig(conf);
    } catch (ex) {
      console.log("ex:", ex);
      const conf: TotemConfig = {
        PrintQRCodeTicket: false,
        PrintType: 0,
      };
      setConfig(conf);
    }
  };

  const setConfig = (conf: TotemConfig) => {
    setTotemConfig(conf);
    const strConfig = JSON.stringify(conf);
    console.log(strConfig);
    setJsonCOnfig(strConfig);
    (window as any).totemConfig = strConfig;
  };

  function Alert(props: any) {
    const success = props?.severity === "success";
    return (
      <MuiAlert
        elevation={6}
        variant="filled"
        {...props}
        className={success ? classes.success : classes.info}
        classes={{
          icon: classes.icon,
        }}
      />
    );
  }

  const copyToClipBoard = async () => {
    await CefSharp.BindObjectAsync("browserService");
    browserService.setClipBoardTextValue(jsonConfig ?? "");
  };

  const classes = useStyles();

  const logo = useMemo(() => (isMee ? meeLogo : meepLogo), [isMee]);

  const handleAtualizar = () => {
    if ((window as any).setConfigTotem && imei) {
      (window as any).setConfigTotem(imei);
    } else {
      console.warn(
        "Algo deu errado, favor fechar e abrir aplicação novamente."
      );
    }
  };

  return (
    <div className="App">
      <div id="totem-data">
        <div>
          <img src={logo} alt="Logo" className={classes.img} style={{
            width: isMee ? 200 : 300,
            height: 80
          }} />
          <Typography className={classes.title}>
            {totemConfig?.TickectName}
          </Typography>
          <Typography className={classes.item}>
            CNPJ: {formatCNPJ(totemConfig?.CNPJ ?? "")}
          </Typography>
          <Typography className={classes.item}>IMEI: {imei}</Typography>
          <Typography className={classes.item}>
            Equipamento: {totemConfig?.EquipamentId}
          </Typography>
          <Typography className={classes.item}>
            Usuário Meep:&nbsp; <b>{totemConfig?.UserAgent}&nbsp;|&nbsp;</b>
            Código único:&nbsp; <b>{totemConfig?.StoreCode}</b>
          </Typography>
          {jsonConfig && (
            <IconButton onClick={copyToClipBoard} className={classes.copy}>
              <FileCopyOutlinedIcon />
            </IconButton>
          )}
        </div>
      </div>
      <div id="messages">
        {messages.map((men) => {
          return (
            <Alert
              style={{ margin: "12px 80px 0px 80px", padding: "0 16px" }}
              severity={men.severity}
            >
              {men.message}
            </Alert>
          );
        })}
      </div>
      <div className={classes.buttons}>
        <Button
          className={classes.button}
          onClick={() => window.close()}
          style={{
            color: isMee ? "#7f47dd" : "#32008E",
            border: `2px solid ${isMee ? "#7f47dd" : "#32008E"}`,
          }}
        >
          Encerrar aplicação
        </Button>
        <Button
          className={classes.button}
          onClick={handleAtualizar}
          style={{
            color: "#FFF",
            border: `2px solid ${isMee ? "#7f47dd" : "#32008E"}`,
            background: isMee ? "#7f47dd" : "#32008E",
          }}
        >
          Atualizar
        </Button>
      </div>
      {cefSharpVersion && (
        <Typography
          className={classes.version}
          color="textSecondary"
          gutterBottom
        >
          {cefSharpVersion}
        </Typography>
      )}
    </div>
  );
}

export default App;
